import Amplify, { API, graphqlOperation } from 'aws-amplify';
import gql from 'graphql-tag';
import graphql_endpoint from '../aws-appsync-url';
import { btPortalClient, swasthCommonsClient } from '../dashApp';

const fetchUrl = {
  BTPORTAL: (
    query,
    params,
    byPassCache = false,
    hideNotification = false,
    fetchPolicy = 'no-cache',
  ) =>
    new Promise((resolve, reject) => {
      if (query?.includes('mutation')) {
        btPortalClient
          .mutate({
            mutation: gql`
              ${query}
            `,
            variables: params,
          })
          .then(data => resolve(data))
          .catch(err => {
            window.notify({
              message: 'A system error occured. For more details click ',
              icon: 'info-circle',
              type: 'error',
              extra: err?.message || err?.errors?.[0]?.message,
            });
            reject(err);
          });
      } else if (query?.includes('query')) {
        btPortalClient
          .watchQuery({
            query: gql`
              ${query}
            `,
            variables: params,
            fetchPolicy,
          })
          .subscribe({
            next: data => {
              if (data.data && !byPassCache) {
                resolve(data);
              }
            },
            error: error => {
              window.notify({
                message: 'A system error occured. For more details click ',
                icon: 'info-circle',
                type: 'error',
                extra: error?.message || error?.errors?.[0]?.message,
              });
              reject(error);
            },
          });
        if (byPassCache) {
          Amplify.configure({
            API: {
              graphql_endpoint: graphql_endpoint.BTPORTAL,
            },
          });

          API.graphql(graphqlOperation(query, params))
            .then(res => resolve(res))
            .catch(error => {
              if (!hideNotification) {
                window.notify({
                  message: 'A system error occured. For more details click ',
                  icon: 'info-circle',
                  type: 'error',
                  extra: error && error.errors && error.errors[0].message,
                });
              }
              reject(error);
            });
        }
      } else {
        Amplify.configure({
          API: {
            graphql_endpoint: graphql_endpoint.BTPORTAL,
          },
        });

        API.graphql(graphqlOperation(query, params))
          .then(res => resolve(res))
          .catch(error => {
            if (!hideNotification) {
              window.notify({
                message: 'A system error occured. For more details click ',
                icon: 'info-circle',
                type: 'error',
                extra: error && error.errors && error.errors[0].message,
              });
            }
            reject(error);
          });
      }
    }),

  SWASTHCOMMONS: (query, params, byPassCache = false, fetchPolicy = 'no-cache') =>
    new Promise((resolve, reject) => {
      if (query?.includes('mutation')) {
        swasthCommonsClient
          .mutate({
            mutation: gql`
              ${query}
            `,
            variables: params,
          })
          .then(data => resolve(data))
          .catch(err => {
            window.notify({
              message: 'A system error occured. For more details click ',
              icon: 'info-circle',
              type: 'error',
              extra: err?.message || err?.errors?.[0]?.message,
            });
            reject(err);
          });
      } else if (query?.includes('query')) {
        swasthCommonsClient
          .watchQuery({
            query: gql`
              ${query}
            `,
            variables: params,
            fetchPolicy,
          })
          .subscribe({
            next: data => {
              if (data.data && !byPassCache) {
                resolve(data);
              }
            },
            error: error => {
              window.notify({
                message: 'A system error occured. For more details click ',
                icon: 'info-circle',
                type: 'error',
                extra: error?.message || error?.errors?.[0]?.message,
              });
              reject(error);
            },
          });
        if (byPassCache) {
          Amplify.configure({
            API: {
              graphql_endpoint: graphql_endpoint.SWASTH,
            },
          });

          API.graphql(graphqlOperation(query, params))
            .then(res => resolve(res))
            .catch(error => {
              window.notify({
                message: 'A system error occured. For more details click ',
                icon: 'info-circle',
                type: 'error',
                extra: error && error.errors && error.errors[0].message,
              });
              reject(error);
            });
        }
      } else {
        Amplify.configure({
          API: {
            graphql_endpoint: graphql_endpoint.SWASTH,
          },
        });

        API.graphql(graphqlOperation(query, params))
          .then(res => resolve(res))
          .catch(error => {
            window.notify({
              message: 'A system error occured. For more details click ',
              icon: 'info-circle',
              type: 'error',
              extra: error && error.errors && error.errors[0].message,
            });
            reject(error);
          });
      }
    }),
  DBT: (query, params) =>
    new Promise((resolve, reject) => {
      Amplify.configure({
        API: {
          graphql_endpoint: graphql_endpoint.DBT,
        },
      });

      API.graphql(graphqlOperation(query, params))
        .then(res => resolve(res))
        .catch(error =>
          window.notify({
            message: 'A system error occured. For more details click ',
            icon: 'info-circle',
            type: 'error',
            extra: error.errors[0].message,
          }),
        );
    }),
};

export default fetchUrl;
